import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';
import { Redirect } from 'react-router-dom';
import App from './components/App/app';
import LoginRegister from './components/Registration/login-register-dialog';
import OAuthCallback from './components/Registration/OAuth2/Shared/oauth-callback';
import PageNotFoundError from './error-page-not-found';
import { selectLoggedIn } from './store/Account/selectors';
import ApiAnalytics from './api/api-analytics';

const Routes = () => {
    const userLoggedIn = useSelector(selectLoggedIn);

    if (userLoggedIn) {
        return <App />;
    } else {
        return (
            <Switch>
                <Redirect exact path="/home" to="/" />
                <Redirect exact path="/index.php" to="/" />
                <Redirect exact path="/index.html" to="/" />
                <Route
                    exact
                    path="/"
                    render={(_) => {
                        ApiAnalytics.postAnalyticsEvent('Non US Investors', 'Visited site');

                        return (
                            <React.Fragment>
                                <LoginRegister
                                    onRegisterSuccess={() => {
                                        ApiAnalytics.postAnalyticsEvent('Non US Investors', 'Registered');
                                    }}
                                    onLoginSuccess={() => {
                                        ApiAnalytics.postAnalyticsEvent('Non US Investors', 'Logged In');
                                    }}
                                />
                            </React.Fragment>
                        );
                    }}
                />

                <Route exact path="/auth/callback" component={OAuthCallback} />
                <Route exact path="/login" render={(_) => <React.Fragment />} />
                <Route exact path="/register" render={(_) => <React.Fragment />} />
                <Route path="/forgot_password" render={(_) => <React.Fragment />} />
                <Route exact path="/404-page-not-found" component={PageNotFoundError} />

                <Route path="/" component={PageNotFoundError} />
            </Switch>
        );
    }
};

export default Routes;
